export default function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// /Users/izizac/Desktop/Biurko — MacBook Pro (Maciej)/sage/node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
// module id = 65
// module chunks = 0